export default __webpack_public_path__ + "static/media/img-0462--montenegro-half-face.2b7ce5bb.png";